import styled from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';

export const TrackWrapper = styled(Flex)`
  height: 16px;
  flex-direction: column;
  justify-content: center;
`;

export const Track = styled(Box)<{ index: number }>`
  height: 8px;
  background: ${({ index, theme }) =>
    index === 1 ? theme.colors.primaryBlue : theme.colors.mediumGrey};
  border-radius: 100px;
`;

export const ThumbLabel = styled(Box)`
  position: absolute;
  font-size: 0.625rem;
  &.thumb-left {
    left: 0;
    bottom: 10px;
  }
  &.thumb-right {
    bottom: 10px;
    right: 0;
  }
`;

export const Thumb = styled(Box)`
  height: 16px;
  width: 16px;
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  outline: none;
  cursor: grab;
  box-shadow: ${({ theme }) => `0px 2px 2px ${theme.colors.shadow}`};
  position: relative;

  &::before {
    content: attr(data-value);
    position: absolute;
    bottom: 100%;
    height: 20px;
    white-space: nowrap;
    font-size: ${({ theme }) => theme.fontSizes.p4};
    left: -100%;
  }
`;
